import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/security-company-dashboard/src/environments/environment';
import { BehaviorSubject, map, Observable, observable } from 'rxjs';
import { AuthService } from '../../auth/services/auth.service';
import { Loader } from '../../core/enums/loader.enum';
import { AttendanceReport } from '../models/attendance-report';
import { Incident } from '../models/incident';
import { VisitorsReport } from '../models/visitors-report';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  private readonly url = environment.api;
  clientId = new BehaviorSubject<number>(0);
  statisticData = new BehaviorSubject<any>(null);
  constructor(private http: HttpClient, private auth: AuthService) { }

  attendanceReportForCompany(startDate: string, loader: Loader, endDate?: string) {
    let companyId = this.auth.snapshot.userInfo?.id;
    if (endDate) {
      return this.http.get<VisitorsReport[]>(
        this.url + `api/Visitor/GetAllByCompanyIdAndDateRang?Id=${companyId}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            loader: loader,
          },
        }
      );
    } else {
      return this.http.get<VisitorsReport[]>(
        this.url + `api/Visitor/GetAllByCompanyId?Id=${companyId}&date=${startDate}`,
        {
          headers: {
            loader: loader,
          },
        }
      );
    }

  }

  attendanceReportForBranch(startDate: string, loader: Loader, endDate?: string) {
    let branchId = this.auth.snapshot.userInfo?.securityCompanyBranch.id;
    if (endDate) {
      return this.http.get<VisitorsReport[]>(
        this.url + `api/Visitor/GetAllByBranshIdAndDateRang?BranshId=${branchId}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            loader: loader,
          },
        }
      );
    } else {
      return this.http.get<VisitorsReport[]>(
        this.url + `api/Visitor/GetAllByBranshId?Id=${branchId}&date=${startDate}`,
        {
          headers: {
            loader: loader,
          },
        }
      );
    }
  }

  getAllAccidentByCompany(startDate: string, endDate: string, loader: Loader) {
    let companyId = this.auth.snapshot.userInfo?.id;
    return this.http
      .get<Incident[]>(
        this.url +
        `api/Incident/GetAllByCompanyIdAndDate?CompanyId=${companyId}&SatrtDate=${startDate}&EndDate=${endDate}`,
        {
          headers: {
            loader: loader,
          },
        }
      )
      .pipe(
        map((res) => {
          res = res.map((e) => {
            e.gallery = e.incidentAttachments.map((a) => a.attachment.fullLink);
            return e;
          });

          return res;
        })
      );
  }
  getAllAccidentByBranch(startDate: string, endDate: string, loader: Loader) {
    let companyId = this.auth.snapshot.userInfo?.id;
    let branchId = this.auth.snapshot.userInfo?.securityCompanyBranch.id
    return this.http
      .get<Incident[]>(
        this.url +
        `api/Incident/GetAllByCompanyIdAndBranchAndDate?CompanyId=${companyId}&branchId=${branchId}&SatrtDate=${startDate}&EndDate=${endDate}`,
        {
          headers: {
            loader: loader,
          },
        }
      )
      .pipe(
        map((res) => {
          res = res.map((e) => {
            e.gallery = e.incidentAttachments.map((a) => a.attachment.fullLink);
            return e;
          });

          return res;
        })
      );
  }
  getAttendanceReport(startDate: string, endDate: string, loader: Loader) {
    let companyId = this.auth.snapshot.userInfo?.id;
    return this.http.get<AttendanceReport[]>(
      this.url +
      `api/Attendance/GetAllByCompanyAndDate?CompanyId=${companyId}&StartDate=${startDate}&EndDate=${endDate}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }
  getAttendanceReportByBranch(startDate: string, endDate: string, loader: Loader) {
    let BranchAppUserId = this.auth.snapshot.userInfo?.appUser.id
    let companyId = this.auth.snapshot.userInfo?.id;
    return this.http.get<AttendanceReport[]>(
      this.url +
      `api/Attendance/GetAllBySecurityCompanyIdAndDateAndBranchId?StartDate=${startDate}&EndDate=${endDate}&SecurityCompanyId=${companyId}&BranchAppUserId=${BranchAppUserId}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }
  getAttendanceSuperVisorReport(
    startDate: string,
    endDate: string,
    loader: Loader
  ) {
    let companyId = this.auth.snapshot.userInfo?.id;
    return this.http.get<any[]>(
      this.url +
      `api/SupervisorAttendance/GetAllBetweenTwoDates?id=${companyId}&StartDate=${startDate}&EndDate=${endDate}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }

  getAttendanceSuperVisorReportAndBranch(
    startDate: string,
    endDate: string,
    loader: Loader
  ) {
    let companyId = this.auth.snapshot.userInfo?.id;
    let branchId = this.auth.snapshot.userInfo?.securityCompanyBranch.id
    return this.http.get<any[]>(
      this.url +
      `api/SupervisorAttendance/GetAllBetweenTwoDatesAndBranch?SecurityCompanyId=${companyId}&StartDate=${startDate}&EndDate=${endDate}&BranchId=${branchId}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }
  getSuperVisorsAttendance(loader: Loader) {
    let companyId = this.auth.snapshot.userInfo?.id;
    return this.http.get<any[]>(
      this.url + `api/SupervisorAttendance/GetAllByCompanyId?id=${companyId}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }
  getAttendanceReportByClient(
    startDate: string,
    endDate: string,
    ClientId: number,
    loader: Loader
  ) {
    let companyId = this.auth.snapshot.userInfo?.id;
    return this.http.get<AttendanceReport[]>(
      this.url +
      `api/Attendance/GetAllByCompanyAndClientIdAndDate?CompanyId=${companyId}&StartDate=${startDate}&EndDate=${endDate}&ClientId=${ClientId}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }

  GetAllByCompanyAndClientIdAndDateAndBranchByBranchAppUserId(startDate: string,
    endDate: string,
    SecurityCompanyClientId: string,
    loader: Loader) {
    let companyId = this.auth.snapshot.userInfo?.id;
    let BranchAppUserId = this.auth.snapshot.userInfo?.appUser?.id;
    return this.http.get<AttendanceReport[]>(
      this.url +
      `api/Attendance/GetAllByCompanyAndClientIdAndDateAndBranch?CompanyId=${companyId}&StartDate=${startDate}&EndDate=${endDate}&SecurityCompanyClientId=${SecurityCompanyClientId}&BranchAppUserId=${BranchAppUserId}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }


  getAttendanceStatisitcReportByClient(
    startDate: string,
    endDate: string,
    ClientId: number,
    loader: Loader
  ) {
    let companyId = this.auth.snapshot.userInfo?.id;
    return this.http.get<AttendanceReport[]>(
      this.url +
      `api/Attendance/GetAttendanceStatsticByClientandLocation?CompanyId=${companyId}&StartDate=${startDate}&EndDate=${endDate}&ClientId=${ClientId}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }

  getAttendanceStatisitcReportByClientAndBranch(
    startDate: string,
    endDate: string,
    ClientId: number,
    loader: Loader
  ) {
    let companyId = this.auth.snapshot.userInfo?.id;
    let branchId = this.auth.snapshot.userInfo?.securityCompanyBranch.id
    return this.http.get<AttendanceReport[]>(
      this.url +
      `api/Attendance/GetAttendanceStatsticByClientandLocationAndBranchId?CompanyId=${companyId}&BranchId=${branchId}&StartDate=${startDate}&EndDate=${endDate}&ClientId=${ClientId}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }
  getAttendanceStatisitcReport(
    startDate: string,
    endDate: string,
    loader: Loader
  ) {
    let companyId = this.auth.snapshot.userInfo?.id;
    return this.http.get(
      this.url +
      `api/Attendance/GetAttendanceStatsticByCompanyId?CompanyId=${companyId}&StartDate=${startDate}&EndDate=${endDate}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }
  getAttendanceStatisitcReportByBranch(
    startDate: string,
    endDate: string,
    loader: Loader
  ) {
    let companyId = this.auth.snapshot.userInfo?.id;
    let branchId = this.auth.snapshot.userInfo?.securityCompanyBranch.id
    return this.http.get(
      this.url +
      `api/Attendance/GetAttendanceStatsticByCompanyIdAndBranchId?CompanyId=${companyId}&branchId=${branchId}&StartDate=${startDate}&EndDate=${endDate}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }
  getData(
    ClientId: number,
    firstDate: string,
    lastDate: string,
    loader: Loader
  ) {
    let companyId = this.auth.snapshot.userInfo?.id;
    return this.http.get(
      this.url +
      `api/Attendance/GetAttendanceStatsticByClientandLocationAndDay?CompanyId=${companyId}&StartDate=${firstDate}&EndDate=${lastDate}&clientId=${ClientId}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }

  getDataByBranch(
    ClientId: number,
    firstDate: string,
    lastDate: string,
    loader: Loader
  ) {
    let companyId = this.auth.snapshot.userInfo?.id;
    let branchId = this.auth.snapshot.userInfo?.securityCompanyBranch.id
    return this.http.get(
      this.url +
      `api/Attendance/GetAttendanceStatsticByClientandLocationAndBranchId?CompanyId=${companyId}&BranchId=${branchId}&StartDate=${firstDate}&EndDate=${lastDate}&clientId=${ClientId}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }
  getALlData(firstDate: string, lastDate: string, loader: Loader) {
    let companyId = this.auth.snapshot.userInfo?.id;
    return this.http.get(
      this.url +
      `api/Attendance/GetAttendanceStatsticLocationAndDay?CompanyId=${companyId}&StartDate=${firstDate}&EndDate=${lastDate}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }


  getALlDataByBranch(firstDate: string, lastDate: string, loader: Loader) {
    let companyId = this.auth.snapshot.userInfo?.id;
    let branchId = this.auth.snapshot.userInfo?.securityCompanyBranch.id
    return this.http.get(
      this.url +
      `api/Attendance/GetAttendanceStatsticLocationAndDayAndBranchId?CompanyId=${companyId}&BranchId=${branchId}&StartDate=${firstDate}&EndDate=${lastDate}`,
      {
        headers: {
          loader: loader,
        },
      }
    );
  }

  getAllAttandanceByLocationId(startDate: string, endDate: string, locationId: string, securityCompanyClientId: string): Observable<any> {
    let securityCompanyId = this.auth.snapshot.userInfo?.id;
    return this.http.get(environment.api + `api/Attendance/GetBySecurityCompanyIdDateLocationSecurityCompanyClientId?StartDate=${startDate}&EndDate=${endDate}&SecurityCompanyId=${securityCompanyId}&LocationId=${locationId}&SecurityCompanyClientId=${securityCompanyClientId}`)
  }

  GetAllByCompanyAndClientIdAndDateAndBranchAndLocation(startDate: string, endDate: string, locationId: string, securityCompanyClientId: string): Observable<any> {
    let BranchAppUserId = this.auth.snapshot.userInfo?.appUser?.id;
    let CompanyId = this.auth.snapshot.userInfo?.id;
    return this.http.get(environment.api + `api/Attendance/GetAllByCompanyAndClientIdAndDateAndBranchAndLocation?CompanyId=${CompanyId}&StartDate=${startDate}&EndDate=${endDate}&SecurityCompanyClientId=${securityCompanyClientId}&BranchAppUserId=${BranchAppUserId}&locationId=${locationId}`)
  }

  getAllMissionsBysecurityCompanyId(companyId: number, page: number, pageSize: number) {
    return this.http.get<any[]>(
      this.url + `api/GuardTask/GetAllSecurityCompanyId?SecurityCompanyId=${companyId}&page=${page}&pageSize=${pageSize}`)
  }

  getAllToursBysecurityCompanyId(companyId: number) {
    return this.http.get<any[]>(
      this.url + `api/GuardTour/GetBySecurityCompany?SecurityCompanyId=${companyId}`)
  }

  getAllToursBySecurityIdAndBranchId(companyId: number, branchId: string) {
    return this.http.get<any[]>(
      this.url + `api/GuardTour/GetBySecurityCompanyAndBranchId?SecurityCompanyId=${companyId}&BranchId=${branchId}`)
  }

  getAllMissionsBysecurityCompanyIdAndBranchId(companyId: number, branchId: string, page: number, pageSize: number) {
    return this.http.get<any[]>(
      this.url + `api/GuardTask/GetAllSecurityCompanyAndBranchId?SecurityCompanyId=${companyId}&BranchId=${branchId}&page=${page}&pageSize=${pageSize}`)
  }

  GlobalApiFilterGetAllSecurityCompanyClientForUserSecurity(AppUserId: any) {
    return this.http.get(this.url + `api/GlobalApiFilter/GetAllSecurityCompanyClientForUserSecurity?AppUserId=${AppUserId}`)
  }

  GlobalApiFilterGetAllSiteLocationByUserAndSCForUserSecurity(SecurityCompanyClientId: string, AppUserId: any) {
    return this.http.get(this.url + `api/GlobalApiFilter/GetAllSiteLocationByUserAndSCForUserSecurity?SecurityCompanyClientId=${SecurityCompanyClientId}&AppUserId=${AppUserId}`)
  }

  GuardTasksReportGetAllForSecurityCompanyFilter(model: object) {
    return this.http.post(this.url + `api/GuardTasksReport/GetAllForSecurityCompanyFilter`, model)
  }
  GuardGuardsReportGetAllForSecurityCompanyFilter(model: object) {
    return this.http.post(this.url + `api/AttendanceReport/GetAllForSecurityCompanyFilter`, model)
  }

  GuardTourReportGetAllForSecurityCompanyFilter(model: object) {
    return this.http.post(this.url + `api/GuardTourReport/GetAllForSecurityCompanyFilter`, model)
  }

  VisitorReportGetAllForSecurityCompanyFilter(model: object) {
    return this.http.post(this.url + `api/VisitorReport/GetAllForSecurityCompanyFilter`, model)
  }

  IncidentsReportGetAllForSecurityCompanyFilter(model: object) {
    return this.http.post(this.url + `api/IncidentsReport/GetAllForSecurityCompanyFilter`, model)
  }
  
  SupervisorAttendanceReportGetAllForSecurityCompanyFilter(model: object) {
    return this.http.post(this.url + `api/SupervisorAttendanceReport/GetAllForSecurityCompanyFilter`, model)
  }
  GlobalApiFilter_GetAllSecurityBranch(companyId: number) {
    return this.http.get(this.url + `api/GlobalApiFilter/GetAllSecurityBranch?SecurityCompanyId=${companyId}`)
  }
  getAllReceivingDeliveringVehicles() {
    let securityCompanyId = this.auth.snapshot.userInfo?.id;
    return this.http.get(environment.api + `api/ReceivingDeliveringVehicles/GetAllBySecurtityCompanyId?SecurtityCompanyId=${securityCompanyId}`)
  }

  getAllInvoiceReportDetails(model:object){
    return this.http.post(this.url + `api/InvoicesReport/GetInvoiceDetails`,model)
  }

  convertImgToBase64(imgs: number[]): Observable<any> {
    return this.http.post(
      environment.api + 'api/Attachment/GetImageBase64',
      imgs
    );
  }

  getAllInvoiceReport(SecurityCompanyID:any){
    return this.http.get(this.url+`api/InvoicesReport/GetAllForSecurityCompany?SecurityCompanyClientId=${SecurityCompanyID}`)
  }

  getAllInvoiceReportForSecurityAndBranch(SecurityCompanyID:any , branchId:string){
    return this.http.get(this.url+`api/InvoicesReport/GetAllForSecurityCompanyAndBranch?SecurityCompanyClientId=${SecurityCompanyID}&BranchId=${branchId}`)
  }

  createInvoice(model:object){
    return this.http.post(this.url+`api/InvoicesReport/CreateInvoice` , model)
  }

  getInvoiceById(invoiceID:string){
    return this.http.get(this.url+`api/InvoicesReport/GetById?Id=${invoiceID}`)
  }

  updateInvoiceStatus(invoiceID:string){
    return this.http.post(this.url+`api/InvoicesReport/UpdateInvoice?InvoiceId=${invoiceID}&invoiceStatus=4`,null)
  }

  UpdateSecurityAdminApprovedBy(model:object){
    return this.http.post(this.url+`api/InvoicesReport/UpdateSecurityAdminApprovedBy` , model)
  }

  GetAllAttendanceWithdrawalLog(AttendanceId:string){
    return this.http.get(this.url+`api/Withdrawal/GetAllAttendanceWithdrawalLog?AttendanceId=${AttendanceId}`)
  }

 UpdateWithdrawalLog(AttendanceId:string , withdrawalStatus:number , Notes:any){
  return this.http.post(this.url+`api/Withdrawal/UpdateWithdrawalLog?Id=${AttendanceId}&withdrawalStatus=${withdrawalStatus}&Notes=${Notes}` , null)
 }
}
